const swymCustomFunctions = {
    fetchLists: function (swat) {
        return new Promise((resolve, reject) => {
            swat.fetchLists({
                callbackFn: resolve,
                errorFn: reject,
            });
        });
    },
    fetchListProductsDetails: function (swat, lid) {
        return new Promise((resolve, reject) => {
            swat.fetchListCtx(
                { lid },
                resolve,
                reject
            );
        });
    },
    createList: function (swat, listName = "My Wishlist") {
        return new Promise((resolve, reject) => {
            swat.createList(
                { lname: listName },
                resolve,
                reject
            );
        });
    },
    renameList: function (swat, name, lid) {
        return new Promise((resolve, reject) => {
            swat.updateList(
                { lname: name, lid },
                resolve,
                reject
            );
        });
    },
    deleteLists: async function (swat, lists) {
        try {
            await Promise.all(
                lists.map((list) =>
                    new Promise((resolve, reject) => {
                        swat.deleteList(
                            list.lid,
                            resolve,
                            reject
                        );
                    })
                )
            );
            await swymCustomFunctions.updateList(swat);
            return "All lists deleted successfully";
        } catch (error) {
            console.error("Error encountered while deleting the lists", error);
            throw error;
        }
    },
    addProductsToList: async function (swat, products, lid) {
        const chunkSize = 10;
        const productChunks = Array.from(
            { length: Math.ceil(products.length / chunkSize) },
            (_, index) => products.slice(index * chunkSize, (index + 1) * chunkSize)
        );

        for (const chunk of productChunks) {
            await new Promise((resolve, reject) => {
                swat.addProductsToList(lid, chunk, resolve, reject);
            });
        }
    },
    removeProductsFromList: function (swat, product, lid) {
        return new Promise((resolve, reject) => {
            swat.deleteFromList(
                lid,
                product,
                resolve,
                reject
            );
        });
    },
    getListsProducts: async function (swat, lists) {
        const products = (
            await Promise.all(
                lists.map((list) =>
                    swymCustomFunctions.fetchListProductsDetails(swat, list.lid)
                )
            )
        ).flat();

        return Object.values(
            products.reduce((acc, { epi, empi, du }) => {
                acc[epi] = { epi, empi, du };
                return acc;
            }, {})
        );
    },
    init: async function (swat) {
        handleStatusApi(swat);
        await swymCustomFunctions.updateList(swat);
        console.log("Swym fetch default list - SUCCESS");
    },
    updateList: async function (swat) {
        let lists = await swymCustomFunctions.fetchLists(swat);

        if (!lists.length) {
            await swymCustomFunctions.createList(swat);
            lists = await swymCustomFunctions.fetchLists(swat); // Refresh after creation
        }

        let singleList =
            lists.find((list) => list.lname.toLowerCase() === "my wishlist") ||
            (await swymCustomFunctions.createList(swat));

        console.log("SwymSyncStatus: Synced Swym Wishlist");

        window.swymCurrentDefaultList = singleList;
        window.swymLists = lists;
    },
};

let StatusCurrentActiveCollection;
let StatusCollectionList;

function handleStatusApi(swat) {
    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
        const [url, options] = args;
        const response = await originalFetch(...args);

        if (url.toString().includes("/saved/")) {
            const action = url.split("/saved/")[1];
            if(action!='wishlist-items'){
                const clonedResponse = response.clone();
                handleSwymImport(clonedResponse, url, options, swat);
            }
        }

        return response;
    };
}

async function handleSwymImport(response, url, options, swat) {
    try {
        const action = url.split("/saved/")[1];
        const requestData = options.body ? JSON.parse(options.body) : {};
        const responseData =
            response.status === 200 ? await response.json() : null;

        if (!responseData) {
            console.warn(`SwymSyncStatus: Failed API request: ${action}`);
            return;
        }

        console.log(`SwymSyncStatus: Handling API ${action}`, {
            requestData,
            responseData,
        });

        if (options.method === "POST") {
            switch (action) {
                case "wishlist":
                    await handleAddToWishlist({swat, requestData, responseData});
                    break;
                case "wishlist/items":
                    let update = await handleAddItemsToWishlist({swat, url, options, requestData, responseData, action});
                    if(update && update.noupdate){
                        return;
                    }
                    break;
                case "wishlist-collection":
                    await handleCreateNewWishlist({swat, requestData, responseData});
                    break;
                case "wishlist-collections":
                    await handleAddItemsToLists({swat, responseData});
                    break;
                default:
                    console.warn(`SwymSyncStatus: Unhandled POST action: ${action}`);
            }
        } else if (options.method === "DELETE") {
            switch (true) {
                case action.includes("wishlist/"):
                    await handleDeleteWishlistItem({swat, action});
                    break;
                case action.includes("wishlist-collection-item/"):
                    await handleDeleteListItem({swat, action});
                    break;
                case action.includes("wishlist-collection/"):
                    await handleDeleteList({swat, action});
                    break;
                default:
                    console.warn(`SwymSyncStatus: Unhandled DELETE action: ${action}`);
            }
        } else if (options.method === "PUT") {
            if (action.includes("wishlist-collection/")) {
                await handleUpdateList({swat, action, requestData, responseData});
            } else {
                console.warn(`SwymSyncStatus: Unhandled PUT action: ${action}`);
            }
        } else if (options.method === "GET") {
            if (action.includes("wishlist-collection/")) {
                await handleFetchList({swat, responseData});
            } else {
                console.warn(`SwymSyncStatus: Unhandled GET action: ${action}`);
            }
        } else {
            console.warn(
                `SwymSyncStatus: Unhandled method: ${options.method} for action: ${action}`
            );
            return;
        } 
        await swymCustomFunctions.updateList(swat);
    } catch (error) {
        console.error("SwymSyncStatus: Error handling Swym import:", error);
    }
}

// Handlers for specific actions
async function handleAddToWishlist({swat, requestData, responseData}) {
    const item = requestData.data?.items?.[0];
    if (item && item.productId && item.variantId && window.swymCurrentDefaultList) {
        const product = {
            empi: item.productId,
            epi: item.variantId,
            du: window.location.origin,
        };
        await swymCustomFunctions.addProductsToList(swat, [product], window.swymCurrentDefaultList.lid);
        console.log("SwymSyncStatus: Product added to wishlist");
    } else {
        console.warn("SwymSyncStatus: Invalid item or missing active list ID for adding to wishlist.");
    }
}

async function handleAddItemsToWishlist({swat, url, options, requestData, responseData, action}) {
    let requestOptions = options;
    if (!window.swymCurrentDefaultList) {
        console.log("SwymSyncStatus: Fetching or creating default list...");
        await swymCustomFunctions.updateList(swat);
    }

    const itemsToAdd = responseData.items
        .filter((item) => item.productId && item.variantId)
        .filter(
            (item) =>
                !window.swymCurrentDefaultList.listcontents.some(
                    (content) => +content.empi === +item.productId && +content.epi === +item.variantId
                )
        )
        .map((item) => ({
            empi: item.productId,
            epi: item.variantId,
            du: window.location.origin,
        }));

    if (itemsToAdd.length) {
        await swymCustomFunctions.addProductsToList(swat, itemsToAdd, window.swymCurrentDefaultList.lid);
        console.log("SwymSyncStatus: Products added to wishlist");
    } else {
        console.log("SwymSyncStatus: No new items to add to wishlist.");
        return { noupdate: true };
    }

    if(responseData.pageCursor){
        requestData.data.pageCursor = responseData.pageCursor;
        requestOptions.body = JSON.stringify(requestData);
        console.log(`SwymSyncStatus: calling staus api ${action} for paginate next page ${responseData.pageCursor}`);
        window.fetch(url, requestOptions);
    }
}

async function handleCreateNewWishlist({swat, requestData, responseData }) {
    const { collection } = responseData;
    StatusCollectionList.push({...collection});
    const { name, items } = collection;
    const newList = await swymCustomFunctions.createList(swat, name);
    console.log("SwymSyncStatus: New wishlist created:", newList);

    if (newList && items.length) {
        const products = items.map((item) => ({
            empi: item.productId,
            epi: item.variantId,
            du: window.location.origin,
        }));
        await swymCustomFunctions.addProductsToList(swat, products, newList.lid);
        console.log("SwymSyncStatus: Items added to new wishlist");
    }
}

async function handleAddItemsToLists({swat, responseData}) {
    const collections = responseData.collections;
    StatusCollectionList = collections;
    for (const collection of collections) {
        
        const existingList = window.swymLists.find((list) => list.lname === collection.name);
        const targetList = existingList || (await swymCustomFunctions.createList(swat, collection.name));

        const itemsToAdd = collection.items.filter(item => item.productId && item.variantId).filter(item =>
            !(targetList.listcontents && targetList.listcontents.some(listContent => +item.productId === listContent.empi && +item.variantId === listContent.epi))
        ).map((item) => ({
            empi: item.productId,
            epi: item.variantId,
            du: window.location.origin,
        }));

        if (itemsToAdd.length) {
            await swymCustomFunctions.addProductsToList(swat, itemsToAdd, targetList.lid);
            console.log(`SwymSyncStatus: Items added to list '${collection.name}'`);
        }
    }
}

async function handleDeleteWishlistItem({swat, action}) {
    if (!window.swymCurrentDefaultList) {
        console.log("SwymSyncStatus: Fetching or creating default list...");
        await swymCustomFunctions.updateList(swat);
    }

    const productId = action.split("wishlist/")[1];
    const product = window.swymCurrentDefaultList.listcontents.find((item) => +item.empi === +productId);

    if (product) {
        let { empi, epi, du } = product;
        await swymCustomFunctions.removeProductsFromList(swat, { empi, epi, du } , window.swymCurrentDefaultList.lid);
        console.log("SwymSyncStatus: Product removed from wishlist");
    } else {
        console.warn(`SwymSyncStatus: Product with ID ${productId} not found in the current default list.`);
    }
}

async function handleDeleteListItem({swat, action}) {
    const itemId = action.split("wishlist-collection-item/")[1];
    const collection = StatusCurrentActiveCollection;

    if (collection) {
        const list = window.swymLists.find((list) => list.lname === collection.name);
        const item = collection.items.find((item) => item.id == itemId);

        if (list && item && item.productId && item.variantId) {
            await swymCustomFunctions.removeProductsFromList(swat, {
                empi: item.productId,
                epi: item.variantId,
                du: window.location.origin,
            }, list.lid);
            console.log("SwymSyncStatus: Item removed from collection");
        }else{
            console.warn("SwymSyncStatus: Invalid item or missing active list ID for removing on wishlist.");
        }
    }
}

async function handleDeleteList({swat, action}) {
    const collectionId = action.split("wishlist-collection/")[1];
    const collection = StatusCollectionList.find((col) => col.uuid === collectionId);
    const list = window.swymLists.find((list) => list.lname === collection.name);

    if (list) {
        await swymCustomFunctions.deleteLists(swat, [list]);
        console.log("SwymSyncStatus: List deleted");
    }
}

async function handleUpdateList({swat, action, requestData, responseData}) {
    const { collection } = requestData.data;

    if (collection.name) {
        let newListName = responseData.collection.name;
        let collectionId = action.split('wishlist-collection/')[1];
        let collectionToRename= StatusCollectionList.find((collection)=>collection.uuid == collectionId);
        const listToUpdate = window.swymLists.find((list) => list.lname === collectionToRename.name);

        if (listToUpdate) {
            await swymCustomFunctions.renameList(swat, newListName, listToUpdate.lid);
            console.log("SwymSyncStatus: List renamed");
        }
    }else if(collection.items){
        let listName = responseData.collection.name;
        const listToUpdate = window.swymLists.find((list) => list.lname === listName);

        const itemsToAdd = collection.items
        .filter((item) => item.productId && item.variantId)
        .filter(
            (item) =>
                !(listToUpdate && listToUpdate.listcontents && listToUpdate.listcontents.some(
                    (content) => +content.empi === +item.productId && +content.epi === +item.variantId
                ))
        )
        .map((item) => ({
            empi: item.productId,
            epi: item.variantId,
            du: window.location.origin,
        }));

        if (itemsToAdd.length) {
            await swymCustomFunctions.addProductsToList(swat, itemsToAdd, window.swymCurrentDefaultList.lid);
            console.log("SwymSyncStatus: Products added to wishlist");
        } else {
            console.log("SwymSyncStatus: No new items to add to wishlist.");
        }
    }
}

async function handleFetchList({swat, responseData}) {
    const collection = responseData.collection;
    StatusCurrentActiveCollection = collection;
    if(!StatusCollectionList){
        StatusCollectionList = [{...collection}];
    }
    if (collection) {
        const existingList = window.swymLists.find((list) => list.lname === collection.name);
        const targetList = existingList || (await swymCustomFunctions.createList(swat, collection.name));

        const itemsToAdd = collection.items.map((item) => ({
            empi: item.productId,
            epi: item.variantId,
            du: window.location.origin,
        }));

        if (itemsToAdd.length) {
            await swymCustomFunctions.addProductsToList(swat, itemsToAdd, targetList.lid);
            console.log("SwymSyncStatus: Items added to list from fetched collection");
        }
    }
}


async function handleSwymResponse(response) {
    console.log("Swym Response", response);
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCustomFunctions.init);
